import React from 'react'
import PropTypes from 'prop-types'

const CreatorItemAdder = function (props) {
  return (
    <div id='todolist-item-add' onClick={props.createTodo}>
      <div id='todo-plus'>+</div>
      <div id='todo-add-title'>Add Item</div>
    </div>
  )
}

CreatorItemAdder.propTypes = {
  createTodo: PropTypes.func.isRequired
}

export default CreatorItemAdder



// WEBPACK FOOTER //
// ./src/components/CreatorItemAdder.js